



















































import {
  computed,
  defineComponent, reactive, ref, watch,
} from '@vue/composition-api';
import { useRouter, useFormat } from '@ideavivat/vivat-2';

import {
  getMaterials,
  getSubJob,
  updateSubJob,
  createSubJobMany,
} from '@/api/index';

import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';
import CommonFormWithQuickMaterialCreator from '@/components/Store/CommonFormWithQuickMaterialCreator.vue';
import useAuth from '@/use/useAuth';
import useSubJob from '@/use/useSubJob';

const NOW: string = useFormat.date().computerShortDate();

const CommonModalWithBrieflySubJobEditor = defineComponent({
  components: {
    CommonModalWithPreset,
    CommonFormWithQuickMaterialCreator,
  },
  setup(props, { root, emit }) {
    const { route } = useRouter();
    const { subJobType } = useSubJob();
    const { hasPermission: checkPermissionHandler } = useAuth();
    function hasPermission(name: string) {
      return checkPermissionHandler(root.$store.getters.me, name);
    }
    const modal = ref(null);
    const materialFilter = computed(() => ({ orderBy: [{ field: 'updated_at', order: 'DESC' }] }));
    const refetchMaterialSearchQuery = ref(false);
    const defaultSubJobValue = reactive({
      productionType: '',
      material: null,
      materialId: '',
      materialCode: '',
      drawingNo: '',
      amount: '',
      unit: '',

      status: 'PENDING',
      processStatus: 'PENDING',

      targetDate: NOW,
      purchaseAmount: '',
      subJobNo: '',
      moduleNo: '',
      brand: '',
      deliveredDate: '',

      remarks: '',
    });

    const getMaterialsResult = (data: any) => data.data.data;
    const form = reactive({
      id: -1,
      productionType: '',
      material: null,
      materialId: '',
      materialCode: '',
      description: '',
      drawingNo: '',
      amount: '',
      unit: '',
      heatTreatment: '',
      surfaceTreatment: '',

      status: 'PENDING',
      processStatus: 'PENDING',

      targetDate: NOW,
      purchaseAmount: '',
      subJobNo: '',
      moduleNo: '',
      brand: '',
      deliveredDate: '',

      remarks: '',
      call: async () => {
        if (form.id !== -1) {
          const result = await updateSubJob(form.id, computedSubJobInput.value);
          if (result) clear();
        } else {
          const result = await createSubJobMany(route.value.params.id, computedSubJobInput.value);
          if (result) clear();
        }
        emit('done');
      },
    });

    const computedSubJobInput = computed(() => ({
      productionType: form.productionType || 'OTHER',
      materialId: (form.material as any).id,
      materialCode: (form.material as any)?.code || form.drawingNo,
      description: form.description,
      drawingNo: form.drawingNo,
      amount: parseInt(form.amount, 10),
      unit: form.unit,
      heatTreatment: form.heatTreatment || 'NONE',
      surfaceTreatment: form.surfaceTreatment || 'NONE',
      targetDate: form.targetDate,
      moduleNo: form.moduleNo,
      processStatus: form.processStatus || 'PENDING',

      purchaseAmount: parseInt(form.purchaseAmount, 10),
      status: form.status,

      remarks: form.remarks,
    }));

    function clear() {
      form.id = -1;
      form.productionType = defaultSubJobValue.productionType;
      form.material = defaultSubJobValue.material;
      form.materialCode = defaultSubJobValue.materialCode;
      form.drawingNo = defaultSubJobValue.drawingNo;
      form.amount = defaultSubJobValue.amount;
      form.purchaseAmount = defaultSubJobValue.purchaseAmount;

      form.unit = defaultSubJobValue.unit;
      form.targetDate = defaultSubJobValue.targetDate;
      form.status = defaultSubJobValue.status;
      form.processStatus = defaultSubJobValue.processStatus;
      form.targetDate = defaultSubJobValue.targetDate;
      form.brand = defaultSubJobValue.brand;
      form.subJobNo = defaultSubJobValue.subJobNo;
      form.moduleNo = defaultSubJobValue.moduleNo;
      form.deliveredDate = defaultSubJobValue.deliveredDate;

      form.remarks = defaultSubJobValue.remarks;
    }

    async function callGetSubJob() {
      const result = (await getSubJob(form.id)).data;

      form.productionType = result.production_type;
      form.material = result.material;
      form.materialCode = result.material_code;
      form.description = result.description;
      form.drawingNo = result.drawing_no;
      form.amount = result.amount;
      form.unit = result.unit;
      form.heatTreatment = result.heat_treatment;
      form.surfaceTreatment = result.surface_treatment;
      form.targetDate = useFormat.date(result.target_date).computerShortDate();
      form.purchaseAmount = result.purchaseAmount;

      form.status = result.status;
      form.processStatus = result.process_status;

      form.brand = result.material.brand;
      form.subJobNo = result.job_no;
      form.moduleNo = result.module_no;

      form.remarks = result.remarks;
    }

    watch(() => form.id, async (newVal, oldVal) => {
      if (newVal !== -1 && newVal !== oldVal) {
        await callGetSubJob();
      }
    });

    function open(id = -1) {
      form.id = id;
      (modal.value as any).open();
    }
    function close() {
      clear();
      (modal.value as any).close();
    }

    function getMaterialDisplay(mat: any) {
      let output = '';
      if ((mat.name && !(mat.code)) || (mat.code && !(mat.name))) output = `${mat.code || mat.name} ${output}`;
      else if (mat.code && mat.name) output = `${mat.code} - ${mat.name} ${output}`;
      if (mat.brand) output = `[${mat.brand}] ${output}`;
      return output;
    }

    return {
      hasPermission,

      subJobType,

      getMaterials,
      getMaterialsResult,
      modal,
      form,
      clear,
      open,
      close,

      refetchMaterialSearchQuery,
      materialFilter,

      getMaterialDisplay,
    };
  },
});

export default CommonModalWithBrieflySubJobEditor;
